import { useEffect, useRef, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAddQuest } from '../lib/addQuest';
import { Cabin } from './Cabin';

export function NavBar({ dayCount }: { dayCount: number }) {
  const { open, openModal } = useAddQuest();
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navRef = useRef<HTMLElement>(null);

  // Close the drawer when the user taps a link (route change).
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  // Close on Escape and on clicks outside the navbar.
  useEffect(() => {
    if (!menuOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setMenuOpen(false);
    };
    const onDown = (e: MouseEvent) => {
      if (navRef.current && !navRef.current.contains(e.target as Node)) {
        setMenuOpen(false);
      }
    };
    window.addEventListener('keydown', onKey);
    window.addEventListener('mousedown', onDown);
    return () => {
      window.removeEventListener('keydown', onKey);
      window.removeEventListener('mousedown', onDown);
    };
  }, [menuOpen]);

  const handleNewClick = () => {
    setMenuOpen(false);
    openModal();
  };

  return (
    <nav ref={navRef} className={`navbar ${menuOpen ? 'navbar--open' : ''}`}>
      <div className="navbar__brand"><Cabin size={18} /><span>HABIT HOLLOW</span></div>
      <button
        type="button"
        className="navbar__burger"
        onClick={() => setMenuOpen(o => !o)}
        aria-expanded={menuOpen}
        aria-label={menuOpen ? 'close menu' : 'open menu'}
      >
        <span /><span /><span />
      </button>
      <div className="navbar__divider" />
      <div className="navbar__tabs" role="menu">
        <NavLink to="/" end className={({ isActive }) => `navbar__tab ${isActive ? 'navbar__tab--active' : ''}`}>TODAY</NavLink>
        <NavLink to="/quests" className={({ isActive }) => `navbar__tab ${isActive ? 'navbar__tab--active' : ''}`}>CHORES</NavLink>
        <button
          type="button"
          onClick={handleNewClick}
          className={`navbar__tab ${open ? 'navbar__tab--active' : ''}`}
        >
          + NEW
        </button>
        <NavLink to="/stats" className={({ isActive }) => `navbar__tab ${isActive ? 'navbar__tab--active' : ''}`}>STATS</NavLink>
        <NavLink to="/calendar" className={({ isActive }) => `navbar__tab ${isActive ? 'navbar__tab--active' : ''}`}>CAL</NavLink>
        <NavLink to="/map" className={({ isActive }) => `navbar__tab ${isActive ? 'navbar__tab--active' : ''}`}>MAP</NavLink>
        <NavLink to="/settings" className={({ isActive }) => `navbar__tab ${isActive ? 'navbar__tab--active' : ''}`}>SETTINGS</NavLink>
      </div>
      <span className="navbar__spacer" />
      <div className="navbar__day">◆ Day {dayCount}</div>
    </nav>
  );
}
